export default __webpack_public_path__ + "static/media/Snd_8_Starts.d849702e.mp3";